import React from 'react';
import { ButtonLink, ButtonLinkProps } from './ButtonLink';

export const ExpandingButtonLink = (props: ButtonLinkProps) => {
    return <ButtonLink {...props} />;
};
